import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { CampaignsImpactDataSchema, DataResponse, GetCampaignsImpactSchema } from "schema"
import { z } from "zod"

type Query = z.input<typeof GetCampaignsImpactSchema>
type Response = DataResponse<z.infer<typeof CampaignsImpactDataSchema>>
type OnSuccessFn = (data: Response) => void

type Props = {
  query?: Query
  onSuccess?: OnSuccessFn
}

export const campaignsImpactQuery = ({ query, onSuccess }: Props = {}) => {
  return queryOptions({
    queryKey: ["campaignsImpact", query?.campaignId],
    queryFn: async () => {
      const { data } = await axios.get<Response>("/campaigns/impact", { params: query })

      onSuccess?.(data)
      return data.data
    },
  })
}
